/* LH | Gift box block for boxes without a colour (wine glass, Leon 25.10.2026). Config and look: snippets/lh-gift-box.liquid.
 *
 * Rules and reasons (plain English):
 * - Same block as the tealight gift box (boxCard in assets/lh-set-picker.js), only without the colour row: heading
 *   "Geschenkverpackung", "Keine Verpackung 0,00€" / "Mit Geschenkverpackung (i) ab 4,95€", then "Wie viele Boxen?"
 *   with 1 to the pieces of the chosen set, always there and pale until "Mit".
 * - The TeeInBlue field (global option "Keine", "1 Box" .. "4 Boxen") stays the source of truth: TeeInBlue adds the box
 *   line and links it to the glass, so Printlabs packs it. The field is hidden and the block clicks its labels.
 * - Which field: one whose priced options add a product in config.products (window.lhTeeAddon from
 *   assets/teeinblue-custom.js knows the add-on of every option).
 * - Pieces: window.lhSetPieces (chosen "Verfügbare Produkte" radio). teeinblue-custom.js also hides box tiles above the
 *   pieces and drops a bigger choice to the highest allowed count, so the hidden field never holds more boxes than glasses.
 * - "Mit" picks the count the customer had before (else 1); a count click picks "Mit"; "Keine" clicks "Keine".
 * - Only one count possible (single glass): the whole count part is hidden, "Mit" alone adds the one box.
 */
(function () {
  if (window.__lhGiftLoaded) return;
  window.__lhGiftLoaded = true;

  var config = null;
  function cfg() {
    if (config) return config;
    var el = document.querySelector('[data-lh-gift-config]');
    try { config = el ? JSON.parse(el.textContent) : null; } catch (e) { config = null; }
    // texts come through Liquid's t filter, which HTML escapes them (FR "d&#39;abord"); the script sets textContent
    if (config && config.t) Object.keys(config.t).forEach(function (k) {
      var d = document.createElement('textarea');
      d.innerHTML = config.t[k];
      config.t[k] = d.value;
    });
    return config;
  }

  var lastN = 1;

  function setAttr(el, k, v) { if (el && el.getAttribute(k) !== v) el.setAttribute(k, v); }
  function money(cents) {
    var shop = typeof window.lhMoney === 'function' ? window.lhMoney(cents) : null; // the market's Liquid money format
    if (shop) return shop;
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    var lang = (document.documentElement.lang || 'de').slice(0, 2);
    try {
      var s = new Intl.NumberFormat(lang, { style: 'currency', currency: cur }).format(cents / 100);
      return cur === 'EUR' ? s.replace(/\s/g, '') : s; // shop writes "4,95€"
    } catch (e) { return ''; }
  }
  function clickInput(i) {
    var l = i && i.parentElement && i.parentElement.querySelector('label');
    if (l) l.click(); else if (i) i.click();
  }
  function pieces() { return typeof window.lhSetPieces === 'function' ? Math.max(1, window.lhSetPieces()) : 1; }
  function track(name, n) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, lh_upsell: 'gift_box', lh_box_count: n });
    } catch (e) {}
  }

  // { field, none: input, counts: [{ input, n, cents }], on: count entry or null }
  // Picture of a count tile (Leon 25.10.2026: tiles with images like the tealight colours): the Shopify image of the
  // box variant ("2 boxes" shows two boxes), from TeeInBlue's add-on variant list.
  function boxImage(id) {
    var list = (window.teeinblueCampaign && window.teeinblueCampaign.addonVariants) || [];
    var v = list.find(function (x) { return String(x.id) === String(id); });
    var src = v && v.featured_image && v.featured_image.src;
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  }
  function boxState() {
    var c = cfg();
    if (!c || typeof window.lhTeeAddon !== 'function') return null;
    var out = null;
    document.querySelectorAll('.tee-customization-form .tee-field').forEach(function (f) {
      if (out) return;
      var ins = f.querySelectorAll(':scope > .tee-field__input input[type="radio"]');
      var counts = [];
      var none = null;
      ins.forEach(function (i) {
        var a = window.lhTeeAddon(i);
        if (a && c.products.indexOf(a.product) !== -1) counts.push({ input: i, n: a.n, cents: a.cents, product: a.product, img: boxImage(a.id) });
        else if (!a) none = i;
      });
      if (counts.length && none) out = { field: f, none: none, counts: counts };
    });
    if (!out) return null;
    out.counts.sort(function (a, b) { return a.n - b.n; });
    out.on = out.counts.find(function (x) { return x.input.checked; }) || null;
    return out;
  }

  var GIFT_ICON = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="13" rx="2"/><path d="M3 12h18M12 8v13M12 8c-1.5-3-5-4-5-1.5S10 8 12 8zM12 8c1.5-3 5-4 5-1.5S14 8 12 8z"/></svg>';
  function build(t, pid) {
    var g = document.createElement('div');
    g.className = 'lh-gift';
    g.setAttribute('data-lh-gift-count', '');
    g.innerHTML =
      '<div class="ck-datacheck__label"><span class="lh-gift__icon">' + GIFT_ICON + '</span><strong data-t="head"></strong></div>' +
      '<div class="ck-datacheck__options">' +
        '<label class="ck-datacheck__option"><input type="radio" name="lh_gift_count_option" value="none" checked><span class="ck-datacheck__content"><span class="ck-datacheck__title" data-t="none"></span><span class="ck-datacheck__price" data-t="zero"></span></span></label>' +
        '<label class="ck-datacheck__option"><input type="radio" name="lh_gift_count_option" value="with"><span class="ck-datacheck__content"><span class="ck-datacheck__title"><span data-t="with"></span><button type="button" class="lh-addon-info" data-lh-addon-info="' + pid + '"></button></span><span class="ck-datacheck__price" data-t="from"></span></span></label>' +
      '</div>' +
      '<div class="lh-gift__pick" data-lh-gift-pick>' +
        '<span class="lh-gift__sh" data-t="qty"></span><div class="lh-gift__qty" role="radiogroup" data-lh-gift-qty></div>' +
        '<span class="lh-gift__hint" data-lh-gift-hint></span>' +
      '</div>';
    var txt = { head: t.head, none: t.none, zero: money(0), with: t.with, qty: t.qty };
    g.querySelectorAll('[data-t]').forEach(function (n) { n.textContent = txt[n.getAttribute('data-t')] || ''; });
    var info = g.querySelector('.lh-addon-info');
    if (!(window.lhAddonInfo || {})[pid]) info.remove();
    else info.setAttribute('aria-label', (t.head || '') + ': Info');
    return g;
  }

  function render() {
    var c = cfg();
    var st = boxState();
    var g = document.querySelector('[data-lh-gift-count]');
    if (!st) { if (g) g.hidden = true; return; }
    var t = c.t || {};
    var max = pieces();
    if (!st.field.classList.contains('lh-box-hidden')) st.field.classList.add('lh-box-hidden');
    if (!g) g = build(t, st.counts[0].product);
    if (st.field.nextElementSibling !== g) st.field.insertAdjacentElement('afterend', g);
    if (g.hidden) g.hidden = false;
    var live = !!st.on;
    if (live) lastN = st.on.n;
    var radios = g.querySelectorAll('input[name="lh_gift_count_option"]');
    if (radios[0].checked === live) radios[0].checked = !live;
    if (radios[1].checked !== live) radios[1].checked = live;
    var single = st.counts.filter(function (x) { return x.n <= max; }).length <= 1;
    // "ab 4,95€" only when there is a choice; with one possible box its price
    var fromTxt = single ? money(st.counts[0].cents) : (t.from || '__P__').replace('__P__', money(st.counts[0].cents));
    var fromEl = g.querySelector('[data-t="from"]');
    if (fromEl.textContent !== fromTxt) fromEl.textContent = fromTxt;
    g.querySelector('[data-lh-gift-pick]').classList.toggle('lh-gift__pick--off', !live);
    var row = g.querySelector('[data-lh-gift-qty]');
    var shown = st.counts.filter(function (x) { return x.n <= max; });
    var key = shown.map(function (x) { return x.n + ':' + x.cents + ':' + (x.img ? 1 : 0); }).join(',') + '|' + (live ? st.on.n : 0);
    if (row.getAttribute('data-key') !== key) {
      row.setAttribute('data-key', key);
      row.replaceChildren();
      shown.forEach(function (x) {
        var q = document.createElement('button');
        q.type = 'button';
        q.className = 'lh-gift__q';
        q.setAttribute('role', 'radio');
        q.setAttribute('data-lh-gift-n', String(x.n));
        q.setAttribute('aria-checked', live && x.n === st.on.n ? 'true' : 'false');
        var l1 = document.createElement('b');
        l1.textContent = x.n === 1 ? (t.one || '1') : (t.many || '__N__').replace('__N__', x.n);
        var l2 = document.createElement('span');
        l2.textContent = '+' + money(x.cents);
        if (x.img) {
          var pic = document.createElement('span');
          pic.className = 'lh-gift__ci';
          var im = document.createElement('img');
          im.alt = '';
          im.width = 56;
          im.height = 56;
          im.src = x.img;
          pic.appendChild(im);
          q.append(pic);
          q.classList.add('lh-gift__q--img');
        }
        q.append(l1, l2);
        row.appendChild(q);
      });
    }
    // Only one count possible (single glass): no count question at all, "Mit" alone adds the one box (Leon 25.10.2026)
    var pick = g.querySelector('[data-lh-gift-pick]');
    if (pick.hidden !== single) pick.hidden = single;
    var hint = g.querySelector('[data-lh-gift-hint]');
    var h = live ? '' : (t.pick || '');
    if (hint.textContent !== h) hint.textContent = h;
  }

  function pickCount(st, n) {
    var max = pieces();
    var want = Math.min(n, max);
    var x = st.counts.find(function (y) { return y.n === want; }) || st.counts[0];
    clickInput(x.input);
    soon();
  }

  document.addEventListener('change', function (e) {
    var r = e.target;
    if (!r || r.name !== 'lh_gift_count_option') return;
    var st = boxState();
    if (!st) return;
    if (r.value === 'none') { clickInput(st.none); track('lh_box_none', 0); soon(); }
    else if (!st.on) { pickCount(st, lastN); track('lh_box_with', lastN); }
  });

  document.addEventListener('click', function (e) {
    var q = e.target.closest && e.target.closest('[data-lh-gift-n]');
    if (!q) return;
    e.preventDefault();
    var st = boxState();
    if (!st) return;
    var n = Number(q.getAttribute('data-lh-gift-n'));
    lastN = n;
    pickCount(st, n);
    track('lh_box_count', n);
  });

  function soon() { [60, 400, 1200].forEach(function (ms) { setTimeout(render, ms); }); }

  // A set change only toggles a class on the "Verfügbare Produkte" radio: render again after it.
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('#tee-field--teeinblue-available-prod')) soon();
  }, true);

  function start() {
    if (!cfg()) return;
    render();
    var pending = false;
    new MutationObserver(function (list) {
      if (pending) return;
      // our own block changes do not count, else every render would trigger the next one
      var outside = list.some(function (m) { return !(m.target.closest && m.target.closest('[data-lh-gift-count]')); });
      if (!outside) return;
      pending = true;
      setTimeout(function () { pending = false; render(); }, 30); // not rAF: it never fires in a tab opened in the background
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'class'] });
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
